import { Dropdown as DropdownComponent, DropdownSize } from 'src/shared/design-system/Dropdown';
import styled from 'styled-components';
import { Colors, Font, Spacing } from 'web-common/src/shared/styles';
import { FOOD_ITEM_DROPDOWN_TEXT } from '../consts';

export const Container = styled.div`
  align-items: center;
  display: flex;
  gap: ${Spacing.HALF};
`;

export const Label = styled.div`
  color: ${Colors.GRAY_DARK_20};
  letter-spacing: 1px;
  text-transform: uppercase;
  ${Font.bySize(Font.Size.XXS, Font.Weight.SEMI_BOLD)}
`;

export const Dropdown = styled(DropdownComponent).attrs(() => ({
  fluid: true,
  placeholder: FOOD_ITEM_DROPDOWN_TEXT.PLACEHOLDER,
  rounded: true,
  size: DropdownSize.S,
}))`
  flex: 1 1 auto;
`;
